import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 1247, suffix: "+", label: "активных клиентов" },
  { value: 184502, suffix: "", label: "выпущено erid" },
  { value: 0, suffix: "", label: "штрафов у клиентов с активной подпиской" },
  { value: 4.9, suffix: "★", label: "средний рейтинг" },
];

function Counter({ value, suffix }: { value: number; suffix: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1500;
    const start = performance.now();
    const isFloat = value % 1 !== 0;
    let raf: number;
    const tick = (t: number) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(isFloat ? +(value * eased).toFixed(1) : Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {typeof n === "number" && n % 1 !== 0 ? n.toFixed(1) : n.toLocaleString("ru-RU")}
      {suffix}
    </span>
  );
}

export function StatsCounter() {
  return (
    <section
      aria-label="Статистика ERIDON"
      className="mx-auto mt-12 w-full max-w-6xl px-4 sm:mt-16"
    >
      <div className="glass-card grid grid-cols-2 gap-4 p-5 sm:grid-cols-4 sm:gap-6 sm:p-7">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            className="text-center"
          >
            <p className="bg-gradient-to-br from-primary to-accent bg-clip-text text-2xl font-extrabold text-transparent sm:text-3xl md:text-4xl">
              <Counter value={s.value} suffix={s.suffix} />
            </p>
            <p className="mt-1 text-[11px] uppercase tracking-wide text-muted-foreground sm:text-xs">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
